import { render, staticRenderFns } from "./FlightSegmentRow.vue?vue&type=template&id=4e96aa4d&scoped=true&"
import script from "./FlightSegmentRow.vue?vue&type=script&lang=js&"
export * from "./FlightSegmentRow.vue?vue&type=script&lang=js&"
import style0 from "./FlightSegmentRow.vue?vue&type=style&index=0&id=4e96aa4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96aa4d",
  null
  
)

export default component.exports